<template>
  <div>
    <template>
      <div class="modal is-active" v-if="showModal">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Delete Notification</p>
            <button
              class="icon is-right"
              @click.prevent="toggleModal()"
              ref="closeIcon"
            >
              <font-awesome-icon :icon="['fal', 'times']" title="Close" />
            </button>
          </header>
          <section class="modal-card-body">
            <div class="modal-body">
              You cannot recover deleted notifications. <br>
              Are you sure you want to delete this notification?
            </div>
            <div class="update-box">
              <button @click.prevent="toggleModal()"
                class="button button-link has-underline"
              >
                Cancel
              </button>
              <button
                class="button is-primary"
                @click.prevent="deleteNearMatchNotification()">
                  Delete Notification
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>

    <div class="document">
      <div class="header">
        <EsHeader>
          <template #header>
            <div class="header-title">
              Notifications
            </div>
          </template>
        </EsHeader>
      </div>
      <es-loader v-if="loading" style="margin: 5rem"/>
      <es-exception
        v-else-if="loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
        margin="0"
        style="padding: 5rem"
      />
      <div v-else class="content">
        <es-form style="padding: 1.15rem 0rem">
          <template #es-form-header>
            <div class="header-container">
              <div v-if="editCurrentPanel">
                <th>
                  <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                    Edit Near Match Notification Details
                </th>
              </div>
              <div v-else>
                <th>
                  <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                    Near Match Notification Details
                </th>
              </div>
              <div class="icons" v-if="!editCurrentPanel && !loading && !loadingError">
                <button class="button button-link"
                    @click="editPanel()" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
                  <font-awesome-icon :icon="['far', 'edit']" size="lg" title="Edit" />
                </button>
                <button class="button button-link"
                    @click="toggleModal()" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')"
                    ref="linkDelete">
                  <font-awesome-icon :icon="['far', 'trash-alt']" size="lg" title="Delete" />
                </button>
                <button class="button button-link"
                    @click="goBackToNotifications()">
                  <font-awesome-icon :icon="['far', 'angle-double-left']" size="lg"
                      title="Go Back" />
                </button>
              </div>
            </div>
          </template>
          <template #es-form>
            <table>
              <tbody>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Job Type
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div class="control">
                      <div class="">
                        Near Match
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Job Trigger Type
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div class="control">
                      <div>
                        {{ scheduleData.job.jobTriggerType }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Job Level
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div class="control">
                      <div>
                        {{ scheduleData.job.jobLevel }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="jobLevel === 'State'">
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Send To
                  </th>
                  <td
                    class="control"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    <span>State Super Users</span>
                  </td>
                </tr>
                <tr v-else>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Send To
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div class="control">
                      <div
                        class="buttons has-addons"
                        v-if="editCurrentPanel"
                      >
                        <button
                          class="button button--form"
                          v-for="(option, index) in filteredSendToOptions"
                          :key="index"
                          @click="sendToType = option.description"
                          :class="{ 'is-active': sendToType == option.description }"
                        >
                          {{ option.description }}
                        </button>
                      </div>
                      <div v-else>
                        {{ scheduleData.notification.sendTo }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Additional Email (optional)
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div class="control" v-if="editCurrentPanel">
                      <input
                        class="input has-text-grey is-italic"
                        type="text"
                        :readonly="!editCurrentPanel"
                        :class="{ 'is-static': !editCurrentPanel }"
                        maxlength="250"
                        v-model="additionalEmail"
                        placeholder="sample@email.com"
                        aria-label="Additional Email (optional)"
                      />
                    </div>
                    <div v-else class="is-italic has-text-grey">
                      {{ scheduleData.notification.additionalEmail || 'N/A' }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Email Template
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div class="control">
                      <div v-if="editCurrentPanel && changeFile"
                        :class="{ 'no-temp': !editCurrentPanel }"
                        class="
                          is-flex
                          flex-direction--column
                          flex-justify--start
                          file
                          has-name
                          is-right
                          is-fullwidth
                        "
                      >
                        <es-email-template-upload-input
                          input-id="id"
                          input-ref="inputFile"
                          :has-error-file="hasErrorFile"
                          @validFileExtensions="setErrors($event)"
                          :selected-files="files"
                        />
                        <div v-if="hasErrorFile" class="help is-danger">
                          {{ errorMsgFile }}
                        </div>
                      </div>
                      <div v-else>
                        <div class="is-flex flex-align--center">
                          <div>{{ scheduleData.notification.template }}</div>
                          <button
                            v-if="editCurrentPanel"
                            @click="changeFile = true"
                            class="button button-link has-underline"
                          >
                            Change
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Frequency Type
                  </th>
                  <td :class="{ 'no-border': editCurrentPanel }">
                    <div
                      class="control buttons has-addons"
                      v-if="editCurrentPanel"
                    >
                      <button
                        class="button button--form"
                        v-for="option in frequencyOptions"
                        :key="option.description"
                        @click.prevent="selectFrequencyType(option)"
                        :class="{ 'is-active': frequencyType === option.description }"
                      >
                        {{ option.description }}
                      </button>
                    </div>
                    <div v-else>
                      {{ scheduleData.schedule.frequencyType }}
                    </div>
                  </td>
                </tr>
                <tr
                  v-if="frequencyType !== 'Daily' &&
                    (frequencyType === 'Monthly' || frequencyType === 'Weekly')">
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Frequency Details
                  </th>
                  <td
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    <div
                      class="control buttons has-addons"
                      v-if="frequencyType === 'Weekly' && editCurrentPanel"
                    >
                      <button
                        class="button button--form"
                        v-for="day in ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
                        :key="day"
                        @click="updateWeeklyFrequency(day)"
                        :class="{ 'is-active': day === weeklyFrequencyDetail }"
                      >
                        {{ day }}
                      </button>
                    </div>
                    <div
                      v-if="frequencyType === 'Monthly' && editCurrentPanel"
                      class="select is-half-width is-pulled-left"
                    >
                      <select
                        class="input"
                        v-model="monthlyFrequencyDetail"
                        title="Frequency Details"
                      >
                      <option
                        v-for="(frequency, index) in getFrequencyDetailOptions()"
                        :key="index"
                        :value="frequency.value"
                      >
                        {{ frequency.label }}
                      </option>
                      </select>
                    </div>
                    <div v-if="!editCurrentPanel">
                      {{ frequencyValue() }}
                      <!-- {{ scheduleData.schedule.frequencyDayOfWeek ||
                      formatDayOfMonth(scheduleData.schedule.frequencyDayOfMonth) }} -->
                    </div>
                  </td>
                </tr>
              <tr>
                <th
                  class="has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Start Time
                </th>
                <td class="no-border selections"
                  :class="{ 'no-border': editCurrentPanel }"
                  v-if="editCurrentPanel"
                >
                  <div class="select">
                    <select class="input" v-model="hourOption"  aria-label="Select Hour">
                      <option
                        v-for="(hour, index) in getHourOptions()"
                        :key="index"
                        :value="hour"
                      >
                        {{ hour }}
                      </option>
                    </select>
                  </div>
                  <strong style="margin: 0 5px;">:</strong>
                  <div class="select">
                    <select class="input" v-model="minuteOption" aria-label="Select Minute">
                      <option
                        v-for="(minute, index) in getMinuteOptions()"
                        :key="index"
                        :value="minute"
                      >
                        {{ minute }}
                      </option>
                    </select>
                  </div>
                  <div style="margin: 0 1rem;">
                    <button
                      class="button button--form"
                      v-for="option in amPmOptions"
                      :key="option.description"
                      @click="amPmType = option.description"
                      :class="{ 'is-active': amPmType == option.description }"
                    >
                      {{ option.description }}
                    </button>
                  </div>
                </td>
                <td v-else>
                  {{ formattedTime(scheduleData.schedule.startTime) }}
                </td>
              </tr>
                <tr>
                  <th
                    class="has-text-grey table-header-normal"
                    :class="{ 'no-border': editCurrentPanel }"
                  >
                    Severity
                  </th>
                  <td>
                    <div class="control">
                      <div
                        class="buttons has-addons"
                        v-if="editCurrentPanel"
                      >
                        <button
                          class="button button--form"
                          v-for="(option, index) in severityOptions"
                          :key="index"
                          @click="severityData = option.description"
                          :class="{ 'is-active': severityData === option.description }"
                        >
                          {{ option.description }}
                        </button>
                      </div>
                      <input
                        v-else
                        class="input no-padding"
                        :class="{ 'is-static': !editCurrentPanel }"
                        type="text"
                        :value="severityData"
                        :readonly="!editCurrentPanel"
                        aria-label="Severity"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </es-form>
        <div v-if="editCurrentPanel"
          class="is-flex flex-justify--end flex-align--center"
          style="margin-right: 2rem; padding-bottom: 2rem"
        >
          <button
            class="button button-link has-underline"
            @click.prevent="cancelPanel()"
            style="margin-right: 1rem"
          >
            Cancel
          </button>
          <button
            class="button is-primary"
            @click.prevent="checkRequiredFields"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faEdit,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faCog } from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsEmailTemplateUploadInput from '@/components/EsEmailTemplateUploadInput.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

library.add(
  faAngleDoubleLeft,
  faEdit,
  faCog,
  faTrashAlt,
  faTimes,
);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
    AccessibilityUtils,
  ],
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
    EsEmailTemplateUploadInput,
  },
  props: {
    scheduleData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    hourOption() {
      this.calculateTime();
    },
    minuteOption() {
      this.calculateTime();
    },
    amPmType() {
      this.calculateTime();
    },
  },
  computed: {
    formattedTime() {
      return (time) => {
        const date = new Date();
        date.setHours(Math.floor(time / 100));
        date.setMinutes(time % 100);
        return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
      };
    },
    filteredSendToOptions() {
      if (this.jobLevel === 'State') {
        return null;
      } if (this.jobLevel === 'District') {
        return [
          { description: 'Location Contact Person(s)' },
          { description: 'Location Administrator Users' },
        ];
      } if (this.jobLevel === 'School') {
        return [
          { description: 'Building Contact Person(s)' },
          { description: 'Building Administrator Users' },
        ];
      }
      return [];
    },
    formDataBody() {
      const formData = new FormData();
      formData.append('jobId', this.scheduleData.job.id);

      formData.append('jobTriggerType', 'Pending Near Match');
      formData.append('jobType', 'Near Match');
      formData.append('jobLevel', this.jobLevel);

      formData.append('notificationId', this.scheduleData.notification.id);

      formData.append('severity', this.severityData);
      formData.append('sendTo', this.sendToType);
      formData.append('additionalEmail', this.additionalEmail);

      if (this.files[0]) {
        const selectedTemplateName = this.files[0].name;
        formData.append('template', selectedTemplateName);
        formData.append('templateContent', this.files[0]);
      } else {
        formData.append('template', this.scheduleData.notification.template);
      }

      formData.append('frequencyType', this.frequencyType);
      formData.append('frequencyDayOfWeek', this.weeklyFrequencyDetail);
      formData.append('frequencyDayOfMonth', this.monthlyFrequencyDetail);
      formData.append('startTime', this.startTime);

      return formData;
    },
  },
  data() {
    return this.initialData();
  },
  created() {
    this.onLoad();
    this.severityOptions = [
      {
        description: 'High',
      },
      {
        description: 'Medium',
      },
      {
        description: 'Low',
      },
    ];
    this.frequencyOptions = [
      {
        description: 'Daily',
      },
      {
        description: 'Weekly',
      },
      {
        description: 'Monthly',
      },
    ];
    this.amPmOptions = [
      {
        description: 'AM',
      },
      {
        description: 'PM',
      },
    ];
  },
  methods: {
    initialData() {
      return {
        editCurrentPanel: false,
        showModal: false,
        loading: false,
        loadingError: false,

        hasErrorFile: false,
        changeFile: false,

        thisSchedule: {},

        jobType: 'Near Match',
        jobTriggerType: 'Pending Near Match',
        additionalEmail: this.scheduleData.notification.additionalEmail,
        files: [],
        frequencyType: this.scheduleData.schedule.frequencyType,
        jobLevel: this.scheduleData.job.jobLevel,

        hourOption: null,
        minuteOption: null,
        amPmType: 'AM',
        startTime: this.scheduleData.schedule.startTime,

        monthlyFrequencyDetail: this.scheduleData.schedule.frequencyDayOfMonth,
        weeklyFrequencyDetail: this.scheduleData.schedule.frequencyDayOfWeek,

        sendToType: this.scheduleData.notification.sendTo,
        severityData: this.scheduleData.notification.severity,
        jobTypeNearMatch: this.scheduleData.job.jobType,
      };
    },
    async updatePanel() {
      try {
        this.loading = true;
        await axios({
          method: 'put',
          url: `schedules/${this.scheduleData.schedule.id}`,
          data: this.formDataBody,
        });
        this.goBackToNotifications();
        this.showNotification('success', ['The Near Match Notification updated successfully.']);
      } catch (e) {
        this.showNotification('danger', ['The Notification could not be updated.']);
      } finally {
        this.loading = false;
      }
    },
    async deleteNearMatchNotification() {
      this.loading = true;
      this.loadingError = false;
      try {
        await axios.delete(`schedules/${this.scheduleData.schedule.id}`);
        this.goBackToNotifications();
        this.showNotification('success', ['The Schedule has been deleted.']);
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    frequencyValue() {
      if (this.scheduleData.schedule.frequencyType === 'Daily') {
        return this.formattedTime(this.scheduleData.schedule.startTime);
      } if (this.scheduleData.schedule.frequencyType === 'Weekly') {
        return this.scheduleData.schedule.frequencyDayOfWeek;
      } if (this.scheduleData.schedule.frequencyType === 'Monthly') {
        return this.formatDayOfMonth(this.scheduleData.schedule.frequencyDayOfMonth);
      }
      return '';
    },
    calculateTime() {
      const hour = parseInt(this.hourOption, 10);
      const minute = parseInt(this.minuteOption, 10);
      let updatedHour = hour;
      if (this.amPmType === 'PM' && hour < 12) {
        updatedHour += 12;
      } else if (this.amPmType === 'AM' && hour === 12) {
        updatedHour = 0;
      }
      const time = updatedHour * 100 + minute;
      this.startTime = time;
    },
    getHourOptions() {
      const options = [];
      for (let i = 1; i <= 12; i += 1) {
        options.push(i.toString());
      }
      return options;
    },
    getMinuteOptions() {
      const options = [];
      for (let i = 0; i <= 59; i += 1) {
        options.push(i.toString().padStart(2, '0'));
      }
      return options;
    },
    getFrequencyDetailOptions() {
      const options = [];
      for (let i = 1; i <= 31; i += 1) {
        let suffix = 'th';
        if (i === 1 || i === 21 || i === 31) {
          suffix = 'st';
        } else if (i === 2 || i === 22) {
          suffix = 'nd';
        } else if (i === 3 || i === 23) {
          suffix = 'rd';
        }
        options.push({
          value: i,
          label: `${i}${suffix}`,
        });
      }
      return options;
    },
    formatDayOfMonth(day) {
      const parsedDay = parseInt(day, 10);
      let suffix = 'th';
      if (parsedDay === 1 || parsedDay === 21 || parsedDay === 31) {
        suffix = 'st';
      } else if (parsedDay === 2 || parsedDay === 22) {
        suffix = 'nd';
      } else if (parsedDay === 3 || parsedDay === 23) {
        suffix = 'rd';
      }
      return `${parsedDay}${suffix}`;
    },
    updateWeeklyFrequency(day) {
      this.weeklyFrequencyDetail = day;
    },
    selectFrequencyType(option) {
      this.frequencyType = option.description;
      if (option.description !== 'Weekly') {
        this.weeklyFrequencyDetail = '';
      }
      if (option.description !== 'Monthly') {
        this.monthlyFrequencyDetail = '';
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.$nextTick(() => {
        const modalOpenFocus = this.$refs.closeIcon;
        const modalCloseFocus = this.$refs.linkDelete;
        this.getFocusModal(modalOpenFocus, modalCloseFocus);
      });
    },
    cancelPanel() {
      this.editCurrentPanel = !this.editCurrentPanel;
      this.changeFile = false;
      this.hasErrorFile = false;
      this.errorMsgFile = null;
      this.frequencyType = this.scheduleData.schedule.frequencyType;
      this.hideNotification();
    },
    goBackToNotifications() {
      this.$emit('viewNearMatchNotificationDetails');
    },
    editPanel() {
      this.editCurrentPanel = !this.editCurrentPanel;
      this.hideNotification();
    },
    checkRequiredFields() {
      if (!this.scheduleData.notification.template && !this.files.length) {
        this.hasErrorFile = true;
        this.errorMsgFile = 'No file chosen. A File is required.';
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      } else if (this.files.length) {
        if (!this.hasErrorFile) {
          this.updatePanel();
        } else {
          this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
        }
      } else {
        this.updatePanel();
      }
    },
    setErrors(value) {
      if (!value) {
        this.hasErrorFile = true;
        this.errorMsgFile = 'File extension is invalid. Valid extensions are \'.txt\' or \'.csv\' or \'.TXT\' or \'.CSV\'';
      } else {
        this.clearErrors();
      }
    },
    clearErrors() {
      this.hideNotification();
      this.hasErrorFile = false;
      this.errorMsgFile = null;
    },
    getThisSchedule() {
      return axios.get(`schedules/${this.scheduleData.schedule.id}`);
    },
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;
        const responses = await Promise.all([
          this.getThisSchedule(),
        ]);
        this.thisSchedule = responses[0].data;
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  table th
    vertical-align: middle
  table td
    vertical-align: middle
    padding-left: 0
    &:first-child
      width: 30%
  .header
    display: flex
    align-items: center
  .no-border
    border: 0
  .property
    padding-left: 0
    font-size: 12px
    width: 70%
  .icons
    margin-left: auto
    width: 100px
    display: flex
    justify-content: space-around
    padding-right: 1rem
  .no-temp
    pointer-events: none
  .no-padding
    padding-left: 0 !important
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
    color: #444
    font-weight: 700
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
  .selections
    display: flex
    align-items: center
  .select:not
    right: 0em
</style>
